<template>
  <header class="seminarTabs" v-if="seminarYears.length > 0">
    <v-container>
      <nav class="seminarTabsNav">
        <ul>
          <li v-for="year in seminarYears" :key="year" :class="{active: isActiveYear(year), 'text-xs-center': true}">
            <a :href="'/tags/' + tagId + '?type=seminars&year=' + year">{{ year }}</a>
          </li>
        </ul>
      </nav>
    </v-container>
  </header>
</template>

<script>
  const querystring = require('querystring')

  export default {
    props: [
      'keyword',
      'seminarYears',
      'activeYear',
      'tagId',
    ],

    methods: {
      isActiveYear (year) {
        if (location.search) {
          const search = location.search.replace('?', '')
          const requestYear = querystring.parse(search).year
          return requestYear ? parseInt(requestYear) === year : new Date().getFullYear() === year;
        }

        return new Date().getFullYear() === year
      }
    }
  }
</script>

<style lang="scss">
  @import '../../sass/variables';

  .seminar{
    &Tabs{margin: 0 0 40px;
      & > .container{padding:0;}
      &Nav{@include centerX;
        ul{@include centerX;list-style-type: none;width:100%;padding-left:0;flex-wrap: wrap;
          li{width:120px;
            a{@include centerXY;height:60px;width:100%;font-size:1.5rem;color:$cText;border-bottom:3px solid cBaseDk(8);font-weight: bold;
              &:hover{opacity:1;color:$cKey;border-bottom:3px solid $cKey;}
            }
            &.active{
              a{border-bottom:3px solid $cKey;}
            }
          }
        }
      }
    }
  }
  // Small
  @media screen and (max-width:750px){
    .archivesTitle{margin-bottom: 15px;}
    .seminar{margin-bottom: 20px;
      &Tabs{position:relative;
        &Nav{
          ul{
            li{width:100px;margin-bottom:10px;
              a{height:50px;font-size:1.1rem;}
            }
          }
        }
      }
    }
  }
</style>
